import { useMutation } from "react-query"
import api from "../client"
import { queryClient, queryKeys } from "../query"
import { OrderImportCSVPayload } from "../types/order"

const postData = async (payload: OrderImportCSVPayload) => {
    try {
        const { data } = await api.post<any>(
            `/orders/import/csv`,
            payload
        )

        queryClient.invalidateQueries(queryKeys.ORDERS(undefined))

        return data
    } catch ({ response: { data } }: any) {
        return data
    }
}

export const useOrderImportCSV = () => {
    return useMutation((payload: OrderImportCSVPayload) => {
        return postData(payload)
    })
}
